export default __webpack_public_path__ + "static/media/rk-grey.1b626091.svg";